"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlerts = exports.DashboardAlertsProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
var sdk_model_1 = require("@gooddata/sdk-model");
var DashboardAlertsContext = react_1.default.createContext({
    alerts: [],
    addAlert: noop_1.default,
    removeAlert: noop_1.default,
    updateAlert: noop_1.default,
});
DashboardAlertsContext.displayName = "DashboardAlertsContext";
function reducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case "add":
            return tslib_1.__assign(tslib_1.__assign({}, state), { alerts: tslib_1.__spreadArrays(((_a = state.alerts) !== null && _a !== void 0 ? _a : []), [action.payload]) });
        case "remove":
            return tslib_1.__assign(tslib_1.__assign({}, state), { alerts: (_b = state.alerts) === null || _b === void 0 ? void 0 : _b.filter(function (alert) { return alert !== action.payload; }) });
        case "update": {
            var index = findIndex_1.default(state.alerts, function (alert) { return sdk_model_1.areObjRefsEqual(alert.ref, action.payload.ref); });
            return tslib_1.__assign(tslib_1.__assign({}, state), { alerts: tslib_1.__spreadArrays(state.alerts.slice(0, index), [action.payload], state.alerts.slice(index + 1)) });
        }
    }
}
/**
 * @internal
 */
exports.DashboardAlertsProvider = function (_a) {
    var children = _a.children, alerts = _a.alerts;
    var _b = react_1.useReducer(reducer, { alerts: alerts }), state = _b[0], dispatch = _b[1];
    var contextValue = {
        alerts: state.alerts,
        addAlert: function (alert) { return dispatch({ type: "add", payload: alert }); },
        removeAlert: function (alert) { return dispatch({ type: "remove", payload: alert }); },
        updateAlert: function (alert) { return dispatch({ type: "update", payload: alert }); },
    };
    return react_1.default.createElement(DashboardAlertsContext.Provider, { value: contextValue }, children);
};
/**
 * @internal
 */
exports.useAlerts = function () {
    return react_1.default.useContext(DashboardAlertsContext);
};
//# sourceMappingURL=DashboardAlertsContext.js.map